import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: 'プロフィール',
  },
});

export const meta: PageMeta = {
  title: strings.title,
  listed: false,
};
